import {
  IdentityAvatarBaseMui,
  IdentityAvatarMuiProps,
} from './IdentityAvatarBaseMui';

/** @deprecated Legacy MUI copy - migrate consumers to the Encore IdentityAvatar and delete. */
export const IdentityAvatarMui = (props: IdentityAvatarMuiProps) => (
  <IdentityAvatarBaseMui
    {...props}
    avatarSrc={props.identityRef?.pictureUri || undefined}
  />
);
